export const DAILY_RECOMMEND_LOGIC_OPTIONS = [
  { label: '通用粮', value: 'COMMON' },
  { label: '品种粮', value: 'BREED' },
  { label: '功能粮', value: 'FUNCTION' },
];

export const PRESCRIPTION_RECOMMEND_LOGIC_OPTIONS = [
  { label: '处方粮', value: 'PRESCRIPTION' },
  { label: '配方粮', value: 'FORMULA' },
];

export const TASK_STATUS_OPTIONS = [
  { label: '全部', value: '' },
  { label: '未生效', value: 0 },
  { label: '生效中', value: 1 },
  { label: '已失效', value: 2 },
];

export const TASK_STATUS_LABEL_MAP: Record<string, string> = {
  '0': '未生效',
  '1': '生效中',
  '2': '已失效',
};

export const MAX_RECOMMEND_GOODS_COUNT = 8;

export const getRecommendLogicOptions = (shopType?: number | null) => {
  return Number(shopType) === 1 ? PRESCRIPTION_RECOMMEND_LOGIC_OPTIONS : DAILY_RECOMMEND_LOGIC_OPTIONS;
};

export const formatRecommendLogic = (recommendOrderList?: string[], shopType?: number | null) => {
  const optionMap = getRecommendLogicOptions(shopType).reduce<Record<string, string>>((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});
  return (recommendOrderList || []).map(item => optionMap[item] || item).join('>');
};

export const isTaskActive = (status?: number | string | null) => Number(status) === 1;
